import { type PropsWithChildren, createContext, useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { TaggedContactsStore } from 'pages/settings/pages/tags/store/TaggedContactsStore'

const TaggedContactsContext = createContext<TaggedContactsStore | null>(null)

export const useTaggedContactsContext = () => {
  const context = useContext(TaggedContactsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with TaggedContactsProvider')

  return context
}

export const TaggedContactsProvider = ({ children }: PropsWithChildren) => {
  const { id } = useParams()
  const entities = useEntitiesContext()
  const [store, setStore] = useState<TaggedContactsStore | null>(null)

  useEffect(() => {
    if (!id) {
      setStore(null)
      return
    }

    const newStore = new TaggedContactsStore(Number(id), entities)

    setStore(newStore)
    newStore.setVisibleUI(true)
    void newStore.init()

    return () => {
      newStore.setVisibleUI(false)
      newStore.dispose()
    }
  }, [id])

  if (!id || !store) return null

  return <TaggedContactsContext.Provider value={store}>{children}</TaggedContactsContext.Provider>
}
